<template>
  <div>
    <b-table
      show-empty
      responsive
      empty-text="Necessário informar a quantidade a ser dividida."
      class="bordered"
      :fields="fields"
      :items="installmentSplittedList"
    >
      <template #cell(description)="row">
        <FormulateInput
          :id="`modal_split-description-${row.index}`"
          v-model="row.item.description"
          :name="`modal_split-description-${row.index}`"
          label=""
        />
      </template>

      <template #cell(documentType)="row">
        <FormulateInput
          :id="`modal_split-documentType-${row.index}`"
          v-model="row.item.documentType"
          :name="`modal_split-documentType-${row.index}`"
          label=""
          type="vue-select"
          :options="documentTypeOptions()"
        />
      </template>

      <template #cell(paymentMethod)="row">
        <e-payment-method
          :id="`modal_split-paymentMethod-${row.index}`"
          v-model="row.item.paymentMethodId"
          :name="`modal_split-paymentMethod-${row.index}`"
          :placeholder="$t('Selecione')"
          :clearable="false"
          required
          :show-label="false"
          :validation-messages="{
            required: $t('Obrigatório'),
          }"
        />
      </template>

      <template #cell(managementAccount)="row">
        <e-management-account
          :id="`modal_split-managementAccount-${row.index}`"
          v-model="row.item.managementAccountId"
          :name="`modal_split-managementAccount-${row.index}`"
          required
          type="Output"
          :show-label="false"
          :validation-messages="{
            required: $t('Obrigatório'),
          }"
        />
      </template>

      <template #cell(value)="row">
        <FormulateInput
          :id="`modal_split-value-${row.index}`"
          v-model="row.item.value"
          :name="`modal_split-value-${row.index}`"
          type="text-number"
          currency="R$"
          :precision="2"
          :validation-messages="{
            required: $t('Obrigatório'),
            min: $t('Deve ser maior que 0.01'),
          }"
          validation="required|min:0.01"
        />
      </template>

      <template #custom-foot>
        <tr>
          <th
            colspan="4"
            class="text-right"
          >
            Total
          </th>
          <th class="text-right">
            {{ getTotalInfos.splittedTotal | currency }}
          </th>
        </tr>
        <tr>
          <th
            colspan="4"
            class="text-right"
          >
            Diferença com a despesa origem
          </th>
          <th
            class="text-right"
            :class="{
              'text-danger': getTotalInfos.difference < 0,
              'text-success': getTotalInfos.difference === 0,
            }"
          >
            {{ getTotalInfos.difference | currency }}
          </th>
        </tr>
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import { financialDomain } from '@/mixins'
import EPaymentMethod from '@/views/components/inputs/EPaymentMethod.vue'
import EManagementAccount from '@/views/components/inputs/EManagementAccount.vue'
import { localListAddItem } from '@/store/utils'

export const getInitialInstallmentSplitForm = () => ({
  id: null,
  description: '',
  value: 0,
  paymentMethodId: null,
  managementAccountId: null,
  documentType: null,
})

export default {
  components: {
    BTable,
    EPaymentMethod,
    EManagementAccount
  },

  mixins: [financialDomain],

  props: {
    installmentOrigin: {
      type: Object,
      default: () => ({})
    },
    installmentSplittedList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {}
  },

  computed: {
    fields() {
      return [
        // {
        //   label: this.$t('Ações'),
        //   key: 'action',
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        //   thStyle: { width: '100px' },
        // },
        {
          label: this.$t('Descrição adicional'),
          key: 'description',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: this.$t('Forma de Pagamento'),
          key: 'paymentMethod',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '200px' },
        },
        {
          label: this.$t('Conta Gerencial'),
          key: 'managementAccount',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '200px' },
        },
        {
          label: this.$t('Tipo do Documento'),
          key: 'documentType',
          thClass: 'text-center',
          tdClass: 'text-right',
          thStyle: { width: '200px', minWidth: '120px' },
        },
        {
          label: this.$t('Valor'),
          key: 'value',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '130px', minWidth: '130px' },
        },
      ]
    },

    getTotalInfos() {
      const splittedTotal = this.installmentSplittedList.reduce(
        (total, installment) => total + (installment.value ?? 0),
        0
      )
      const diff = (this.installmentOrigin?.value ?? 0) - splittedTotal

      return {
        difference: diff,
        total: this.installmentOrigin?.value,
        splittedTotal,
      }
    },
  },

  methods: {
    getSplittedItems(quantity, { paymentMethodId, managementAccountId, documentType } = {}) {
      const defaultData = {
        ...getInitialInstallmentSplitForm(),
        paymentMethodId,
        managementAccountId,
        documentType,
      }

      let localQuantity = quantity - (this.installmentSplittedList?.length ?? 0)

      if (localQuantity > 0) {
        let result = []
        localQuantity = quantity - (this.installmentSplittedList?.length ?? 0)

        for (let i = 0; i < (localQuantity || 0); i += 1) {
          result = localListAddItem(result, defaultData)
        }

        return [...this.installmentSplittedList, ...result]
      }

      if (localQuantity < 0) {
        const result = [...this.installmentSplittedList]
        result.splice(localQuantity)

        return result
      }

      return []
    },

    onRemoveInstallment(item) {
      this.$emit('remove', item)
    },
  },
}
</script>

<style lang="scss" scoped></style>
